import { MutableRefObject } from 'react';

export enum ColorCombinationEnum {
  COMPLEMENTARY = 'Complementary',
  MONOCHROMATIC = 'Monochromatic',
  ANALOGOUS = 'Analogous',
  TRIADIC = 'Triadic',
  TETRADIC = 'Tetradic',
}

export type TClassnames = string | Record<string, boolean>;

export type IReactRef =
  | ((instance: HTMLDivElement | null) => void)
  | MutableRefObject<HTMLDivElement | null>
  | null;

export type CombinatedColorsType = {
  mainColor: any;
  firstColor: any;
  secondColor: any;
  thirdColor: any;
};

export enum CombinatedColorsEnum {
  MAIN_COLOR = 'mainColor',
  FIRST_COLOR = 'firstColor',
  SECOND_COLOR = 'secondColor',
  THIRD_COLOR = 'thirdColor',
}
